export { default } from './Campus';
export type { Props } from './Campus';
